import { Reveal } from './Reveal';

/**
 * Gradient call-to-action band used at the foot of marketing pages.
 * Pass the action buttons as children.
 */
export function CtaBand({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
}) {
  return (
    <section className="pb-16 sm:pb-24 pt-4">
      <div className="section">
        <Reveal>
          <div className="relative overflow-hidden rounded-3xl bg-brand-gradient shadow-glow-green text-center p-10 sm:p-16">
            <div className="absolute inset-0 noise opacity-[0.07] mix-blend-overlay" aria-hidden="true" />
            <div className="absolute -bottom-24 left-1/2 -translate-x-1/2 w-[30rem] h-[30rem] rounded-full bg-mustard-gold/15 blur-3xl animate-glow-pulse" aria-hidden="true" />
            <div className="relative">
              <h2 className="font-display text-2xl sm:text-4xl font-bold text-white mb-4 tracking-display">
                {title}
              </h2>
              {subtitle && <p className="text-white/70 mb-8 max-w-md mx-auto">{subtitle}</p>}
              <div className="flex flex-col sm:flex-row gap-3 justify-center">{children}</div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
